// These values are also used for class names
export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Grey = 'grey',
  Red = 'red',
  RedOutline = 'redOutline',
  Transparent = 'transparent',
  Electric = 'electric',
  ElectricSecondary = 'electricSecondary',
  West = 'west',
  WestSecondary = 'westSecondary',
}
